export default __webpack_public_path__ + "static/media/RESIDUAL PRESSURE OF PNEUMATIC ACCIDENT SIMULATOR.9947e0d4.jpg";